export default {
  lineHeight: {
    lineHeightBase: "1rem",
    lineHeightTight: "1.2rem",
    lineHeightNormal: "1.5rem", //24px
    lineHeightRelaxed: "1.7rem",
    lineHeightMedium: "2.25rem", //36px
    lineHeightLarge: "3.75rem",
  },
};
